import api from './api';

export const spendOptimizationService = {
  analyzeSpend: async (data) => {
    try {
      const response = await api.post('/finance/spend/analyze', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getSpendAnalysis: async () => {
    const response = await api.get('/finance/spend/analyses');
    return response.data;
  },
  
  getRecommendations: async (analysisId) => {
    try {
      const response = await api.get('/finance/spend/recommendations', { params: { analysisId } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  generateRecommendations: async (data) => {
    try {
      const response = await api.post('/finance/spend/recommendations', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateRecommendation: async (recommendationId, data) => {
    try {
      const response = await api.put(`/finance/spend/recommendations/${recommendationId}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getSavingsTracking: async (params = {}) => {
    try {
      const response = await api.get('/finance/spend/savings-tracking', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  trackSavings: async (recommendationId, data) => {
    try {
      const response = await api.post('/finance/spend/savings-tracking', { ...data, recommendationId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getSpendAnalytics: async () => {
    try {
      const response = await api.get('/finance/spend/analytics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
